const nav = document.querySelector('.primary-navigation');
const toggle = document.querySelector('[data-nav-toggle]');
const closeButton = document.querySelector('[data-nav-close]');

function setOpen(isOpen) {
  nav.classList.toggle('primary-navigation--open', isOpen);
  toggle.setAttribute('aria-expanded', String(isOpen));
}

if (nav && toggle && closeButton) {
  toggle.addEventListener('click', () => setOpen(!nav.classList.contains('primary-navigation--open')));
  closeButton.addEventListener('click', () => setOpen(false));
}
